export const messages = {
  en: {
    addMaintainancePlan: {
      title: 'Add Maintenance Plan',
      planName: 'Plan Name',
      planNamePlaceholder: 'Required, please enter plan name',
      standard: 'Maintenance Standard',
      standardPlaceholder: 'Required, please select maintenance standard',
      period: 'Maintenance Cycle',
      periodPlaceholder: 'Required, please select inspection cycle',
      month: 'Month',
      monthUnit: 'Month',
      day: 'Day',
      dayUnit: 'Day',
      fixedDays: 'Fixed Days',
      fixedDaysPlaceholder: 'Required, please enter days',
      startDate: 'Start Date',
      startDatePlaceholder: 'Required, please enter start date',
      endDate: 'End Date',
      endDatePlaceholder: 'Required, please enter end date',
      staff: 'Select Staff',
      machine: 'Maintenance Equipment',
      machinePlaceholder: 'Required, please select equipment',
      saveSuccess: 'Added successfully',
      saveError: 'Failed to add',
      validate: {
        planNameRequired: 'Plan name cannot be empty',
        standardRequired: 'Maintenance standard cannot be empty',
        periodRequired: 'Maintenance cycle cannot be empty',
        monthRequired: 'Month cannot be empty',
        dayRequired: 'Day cannot be empty',
        fixedDaysRequired: 'Fixed days cannot be empty',
        startDateRequired: 'Start date cannot be empty',
        endDateRequired: 'End date cannot be empty',
        machineRequired: 'Equipment cannot be empty'
      }
    }
  },
  zh: {
    addMaintainancePlan: {
      title: '添加保养计划',
      planName: '计划名称',
      planNamePlaceholder: '必填，请填写计划名称',
      standard: '保养标准',
      standardPlaceholder: '必填，请选择保养标准',
      period: '保养周期',
      periodPlaceholder: '必填，请选择巡检周期',
      month: '月',
      monthUnit: '月',
      day: '日',
      dayUnit: '日',
      fixedDays: '固定天数',
      fixedDaysPlaceholder: '必填，请填写多少天后保养一次',
      startDate: '开始日期',
      startDatePlaceholder: '必填，请填写开始日期',
      endDate: '结束日期',
      endDatePlaceholder: '必填，请填写结束日期',
      staff: '选择员工',
      machine: '保养设备',
      machinePlaceholder: '必填，请选择设备',
      saveSuccess: '添加成功',
      saveError: '添加失败',
      validate: {
        planNameRequired: '计划名称不能为空',
        standardRequired: '保养标准不能为空',
        periodRequired: '保养周期不能为空',
        monthRequired: '月不能为空',
        dayRequired: '日不能为空',
        fixedDaysRequired: '固定天数不能为空',
        startDateRequired: '开始日期不能为空',
        endDateRequired: '结束日期不能为空',
machineRequired: '设备不能为空'
      }
    }
  },
  'zh-TW': {
    addMaintainancePlan: {
      title: '添加保養計劃',
      planName: '計劃名稱',
      planNamePlaceholder: '必填，請填寫計劃名稱',
      standard: '保養標準',
      standardPlaceholder: '必填，請選擇保養標準',
      period: '保養週期',
      periodPlaceholder: '必填，請選擇巡檢週期',
      month: '月',
      monthUnit: '月',
      day: '日',
      dayUnit: '日',
      fixedDays: '固定天數',
      fixedDaysPlaceholder: '必填，請填寫多少天後保養一次',
      startDate: '開始日期',
      startDatePlaceholder: '必填，請填寫開始日期',
      endDate: '結束日期',
      endDatePlaceholder: '必填，請填寫結束日期',
      staff: '選擇員工',
      machine: '保養設備',
      machinePlaceholder: '必填，請選擇設備',
      saveSuccess: '添加成功',
      saveError: '添加失敗',
      validate: {
        planNameRequired: '計劃名稱不能為空',
        standardRequired: '保養標準不能為空',
        periodRequired: '保養週期不能為空',
        monthRequired: '月不能為空',
        dayRequired: '日不能為空',
        fixedDaysRequired: '固定天數不能為空',
        startDateRequired: '開始日期不能為空',
        endDateRequired: '結束日期不能為空',
        machineRequired: '設備不能為空'
      }
    }
  }
}